import {
    Pagination,
    Dialog,
    Autocomplete,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Input,
    Radio,
    RadioButton,
    RadioGroup,
    Select,
    Switch,
    Option,
    Button,
    ButtonGroup,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Popover,
    Tabs,
    TabPane,
    Table,
    TableColumn,
    Row,
    Col,
    Progress,
    Card,
    Steps,
    Step,
    Collapse,
    CollapseItem,
    Container,
    Header,
    Aside,
    Main,
    Loading,
    MessageBox,
    Message,
    Notification,
    Form,
    FormItem,
    InfiniteScroll,
    Scrollbar
  } from 'element-ui';

  const element = {
    install: function (Vue) {
      Vue.use(Pagination);
      Vue.use(Dialog);
      Vue.use(Autocomplete);
      Vue.use(Dropdown);
      Vue.use(DropdownMenu);
      Vue.use(DropdownItem);
      Vue.use(Input);
      Vue.use(Select);
      Vue.use(Radio);
      Vue.use(RadioButton);
      Vue.use(RadioGroup);
      Vue.use(Switch);
      Vue.use(Option);
      Vue.use(Button);
      Vue.use(ButtonGroup);
      Vue.use(Checkbox);
      Vue.use(CheckboxButton);
      Vue.use(CheckboxGroup);
      Vue.use(Popover);
      Vue.use(Tabs);
      Vue.use(TabPane);
      Vue.use(Table);
      Vue.use(TableColumn);
      Vue.use(Row);
      Vue.use(Col);
      Vue.use(Progress);
      Vue.use(Card);
      Vue.use(Steps);
      Vue.use(Step);
      Vue.use(Collapse);
      Vue.use(CollapseItem);
      Vue.use(Container);
      Vue.use(Header);
      Vue.use(Aside);
      Vue.use(Main);
      Vue.use(Form);
      Vue.use(FormItem);
      Vue.use(InfiniteScroll);
      Vue.use(Scrollbar);
      Vue.use(Loading.directive);

      Vue.prototype.$loading = Loading.service;
      Vue.prototype.$msgbox = MessageBox;
      Vue.prototype.$alert = MessageBox.alert;
      Vue.prototype.$confirm = MessageBox.confirm;
      Vue.prototype.$prompt = MessageBox.prompt;
      Vue.prototype.$notify = Notification;
      Vue.prototype.$message = Message;
    }
  }

  export default element



// WEBPACK FOOTER //
// ./src/element.js